<script setup lang="ts">
import { Icon } from '@iconify/vue'
interface Props {
  title: string
  step: number
  active: boolean
}
defineProps<Props>()
</script>

<template>
  <div class="w-full flex flex-col gap-6">
    <!-- Left -->
    <div class="shrink-0">
      <Icon v-if="active" class="step step__active" icon="material-symbols:check" />
      <p v-if="!active" class="step step__inactive">{{ step }}</p>
      <el-text class="text-text-tertiary font-bold">{{ title }}</el-text>
    </div>
    <!-- Right -->
    <div class="flex flex-col gap-6 items-start w-full px-[50px]" :span="16">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss">
// Left number with check and outline when in active state
.step {
  background-color: var(--fill-tertiary);
  padding: 0.3em;
  border-radius: 50%;
  width: 2em;
  height: 2em;
  display: inline-block;
  text-align: center;
  margin: 0 0.7em;

  &__active {
    border: 1px solid var(--component-stroke-blue);

    path {
      fill: var(--component-stroke-blue);
    }
  }
}
</style>
